module.exports = __webpack_public_path__ + "img/a1.2e68722c.jpg";